export default "__VITE_ASSET__CwTy5DZ$__"